import { Decimal } from '../../datastructures';
import { configAtom } from '../configAtom';
import { createAsyncAtom } from '../../lib/state';
import lendAllocationsAtom from '../claim/lendAllocationsAtom';

export type AssetRewardsApyMap = { [assetAddress: string]: Decimal };

const assetRewardsApyAtom = createAsyncAtom(async get => {
  const config = await get(configAtom);
  const allocations = await get(lendAllocationsAtom);

  const assets = config.assets;
  const rewardsAllocationMap: { [assetAddress: string]: Decimal } = {};

  Object.entries(assets).map(([, assetConfig]) => {
    if (assetConfig.defiSpringRewards) {
      const dailyAllocations = allocations[assetConfig.ticker] ?? [];
      const latestAllocation = dailyAllocations[dailyAllocations.length - 1];

      if (latestAllocation) {
        const strkGrantApr = new Decimal(latestAllocation.strk_grant_apr_nrs);

        rewardsAllocationMap[assetConfig.address] = strkGrantApr;
      } else {
        rewardsAllocationMap[assetConfig.address] = Decimal.ZERO;
      }
    } else {
      rewardsAllocationMap[assetConfig.address] = Decimal.ZERO;
    }
  });

  return rewardsAllocationMap;
});

export default assetRewardsApyAtom;
